








































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import { TransportVehicle } from "@/models";
import { transportVehicleService } from "@/services";

@Component
export default class VehicleSelectDialog extends Vue {
    @Prop() favoriteOnly!: boolean;
    @Prop() value!: boolean;

    innerValue: boolean = false;

    vehicles: null | Array<{ vehicle: TransportVehicle; favorite: boolean }> = null;

    search = "";

    headers: any = null;

    localStorageKey = "mobisulo.selectedvehicleid";

    @Watch("value")
    valueChanged() {
        if (this.value !== this.innerValue) {
            this.innerValue = this.value;
        }
    }

    @Watch("innerValue")
    innerValueChanged() {
        if (this.innerValue !== this.value) {
            this.$emit("input", this.innerValue);
        }
    }

    async mounted() {
        this.headers = [
            {
                text: this.$t("vehicleSelectDialog.registerNumber"),
                value: "vehicle.registerNumber"
            },
            {
                text: this.$t("vehicleSelectDialog.company"),
                value: "vehicle.party.partyName"
            }
        ];

        this.innerValue = this.value;

        this.vehicles = (
            await transportVehicleService.searchVehicles({
                kind: ["Truck"],
                hasRegisterNumber: true,
                enabled: true,
                favorite: this.favoriteOnly ? true : null,
            })
        ).items.map(v => ({ favorite: false, vehicle: v }));

        if (this.value) {
            if (this.vehicles.length === 1) {
                this.select(this.vehicles[0]);
            }

            const lastVehicleId = localStorage.getItem(this.localStorageKey);
            if (lastVehicleId) {
                const vehicle = this.vehicles.find(
                    v => v.vehicle.vehicleId === lastVehicleId
                );
                if (vehicle) {
                    this.select(vehicle);
                }
            }
        }
    }

    select(vehicle: { vehicle: TransportVehicle }) {
        localStorage.setItem(this.localStorageKey, vehicle.vehicle.vehicleId);
        this.$emit("input:vehicle", vehicle.vehicle);
        this.$emit("input", false);
    }
}
